export const assetContainerTypes = {
    
   
   ASSET_CONTAINER_TOGGLE_RESORT : 'ASSET_CONTAINER_TOGGLE_RESORT',

   ASSET_CONTAINER_SAVE_ALBUM_SORT : 'ASSET_CONTAINER_SAVE_ALBUM_SORT',
   ASSET_CONTAINER_SAVE_ALBUM_SORT_SUCCESS : 'ASSET_CONTAINER_SAVE_ALBUM_SORT_SUCCESS',
   ASSET_CONTAINER_SAVE_ALBUM_SORT_FAILURE : 'ASSET_CONTAINER_SAVE_ALBUM_SORT_FAILURE',
   ASSET_CONTAINER_MOVE_ASSET_AFTER: 'ASSET_CONTAINER_MOVE_ASSET_AFTER',
   ASSET_CONTAINER_START_RESORT: 'ASSET_CONTAINER_START_RESORT',
   ASSET_CONTAINER_START_RESORT_ALBUM: 'ASSET_CONTAINER_START_RESORT_ALBUM',
   ASSET_CONTAINER_STOP_RESORT: 'ASSET_CONTAINER_STOP_RESORT',
   ASSET_CONTAINER_STOP_RESORT_ALBUM: 'ASSET_CONTAINER_STOP_RESORT_ALBUM',
   ASSET_CONTAINER_CANCEL_RESORT:'ASSET_CONTAINER_CANCEL_RESORT',
   ASSET_CONTAINER_CANCEL_RESORT_ALBUM:'ASSET_CONTAINER_CANCEL_RESORT_ALBUM',

   ASSET_CONTAINER_DRAG_START: "ASSET_CONTAINER_DRAG_START",
   ASSET_CONTAINER_MOVE_ALBUM_ASSET_AFTER: "ASSET_CONTAINER_MOVE_ALBUM_ASSET_AFTER"


};


// WEBPACK FOOTER //
// ./src/assetContainer/actions/asset-container-action-types.js